(() => {
  const selector = '[data-specs-download]';

  const getFilename = (url) => {
    try {
      const urlWithoutQuery = url.split('?')[0];
      const parts = urlWithoutQuery.split('/');
      return parts[parts.length - 1] || 'download';
    } catch (e) {
      return 'download';
    }
  };

  const forceDownload = async (url, filename) => {
    const res = await fetch(url, { credentials: 'omit' });
    if (!res.ok) throw new Error(`Download failed (${res.status})`);

    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);

    try {
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = filename || getFilename(url);
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } finally {
      // Give the browser a tick to start the download
      setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    }
  };

  document.addEventListener('click', async (e) => {
    const link = e.target.closest(selector);
    if (!link) return;

    const url = link.getAttribute('href') || link.dataset.url;
    if (!url) return;

    e.preventDefault();

    const filename = link.dataset.filename || getFilename(url);

    // Best-effort UX: disable repeated clicks during download
    link.setAttribute('aria-busy', 'true');
    link.style.pointerEvents = 'none';

    try {
      await forceDownload(url, filename);
    } catch (err) {
      // Fallback: open the asset in a new tab
      window.open(url, '_blank', 'noopener,noreferrer');
    } finally {
      link.removeAttribute('aria-busy');
      link.style.pointerEvents = '';
    }
  });
})();
